import { IconName } from '@billy/design-system'
import { TFunction } from 'i18next'

import { InvoicesTableStaticActionType } from '../enums/InvoicesTableStaticActionType'
import { InvoicesTableStaticActionItem } from '../types/InvoicesTableStaticActionItem'

interface GetInvoicesTableStaticActionsProps {
  duplicateInvoiceUrl: string
  createCreditNoteUrl: string
  canRegisterPayment: boolean
  t: TFunction
}

export const getInvoicesTableStaticActions = ({
  duplicateInvoiceUrl,
  createCreditNoteUrl,
  canRegisterPayment,
  t,
}: GetInvoicesTableStaticActionsProps) => {
  const items: InvoicesTableStaticActionItem[] = [
    {
      children: t('invoices.table.static_actions.credit'),
      iconLeft: 'fileSpreadsheet' as IconName,
      id: InvoicesTableStaticActionType.Credit,
      to: createCreditNoteUrl,
      value: InvoicesTableStaticActionType.Credit,
    },
    {
      children: t('invoices.table.static_actions.duplicate'),
      iconLeft: 'copy' as IconName,
      id: InvoicesTableStaticActionType.Duplicate,
      to: duplicateInvoiceUrl,
      value: InvoicesTableStaticActionType.Duplicate,
    },
    {
      children: t('invoices.table.static_actions.void'),
      iconLeft: 'circleX' as IconName,
      id: InvoicesTableStaticActionType.Void,
      value: InvoicesTableStaticActionType.Void,
    },
  ]

  if (canRegisterPayment) {
    items.unshift({
      children: t('invoices.table.static_actions.register_payment'),
      iconLeft: 'handCoins' as IconName,
      id: InvoicesTableStaticActionType.RegisterPayment,
      value: InvoicesTableStaticActionType.RegisterPayment,
    })
  }

  return items
}
